import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { AutoUnsubscribeComponent } from '../shared/components/auto-unsubscribe';

type DialogData = {
  remainingTimeInSeconds: number;
};

@Component({
  selector: 'app-timeout-dialog',
  templateUrl: './timeout-dialog.component.html',
  styleUrls: ['./timeout-dialog.component.scss'],
})
export class TimeoutDialogComponent extends AutoUnsubscribeComponent implements OnInit {
  remainingTime: number;
  remainingTimeText: string;
  timer: any;

  constructor(
    public dialogRef: MatDialogRef<TimeoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    private router: Router,
    private authService: AuthenticationService,
    private dialog: MatDialog
  ) {
    super();
    this.remainingTime = this.data.remainingTimeInSeconds;
  }

  ngOnInit(): void {
    this.timer = setInterval(() => {
      if (this.remainingTime <= 0) {
        clearInterval(this.timer);
        this.onEndSession();
        return;
      }

      this.remainingTime--;

      if (this.remainingTime <= 60) {
        this.remainingTimeText = `${this.remainingTime} sec`;
      } else {
        this.remainingTimeText = `${Math.floor(
          this.remainingTime / 60
        )} min and ${Math.floor(this.remainingTime % 60)} sec`;
      }
    }, 1000);
  }

  closeDialog() {
    clearInterval(this.timer);
    this.dialogRef.close();
  }

  onContinue() {
    const signInSub$ = this.authService.signIn().subscribe((result: any) => {
      if (result) {
        let userInfo = JSON.stringify(result);
        sessionStorage.setItem('userInfo', userInfo);
        localStorage.setItem('userInfo', userInfo);

        this.authService.refreshAccessToken().subscribe(() => {
          this.closeDialog();
        }, error => {
          this.openErrorDialog(error);
        })
      }
    }, error => {
      this.openErrorDialog(error);
    });
    this.addSubscriptions(signInSub$);
  }

  openErrorDialog(error: any) {
    clearInterval(this.timer);
    let dataStructure = {
      errorType: ''.concat(error.status, ' ', error.statusText),
      errorDescription: error.error && error.error.message || ''
    };
    this.dialog.open(ErrorDialogComponent, {
      data: dataStructure,
      disableClose: true
    });
  }

  onEndSession() {
    sessionStorage.clear();
    this.closeDialog();
    this.router.navigate(['/login']);
  }
}
